import request from '../utils/request'

export async function batchArray (requests) {
  return request('batch', {
    data: requests
  })
}

export async function batchObject (url, objectId, method, params) {
  return request(url + `/${objectId}`, {
  	type: 'batchObject',
  	method: method,
    data: params
  })
}


// WEBPACK FOOTER //
// ./src/services/batch.js